import styled from "styled-components";

export const WorkspaceDetailContainer = styled.div`
  padding-inline: 28px;
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
`;

export const LoadingContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 20px;
  flex: 1;
  min-height: 0;
`;

export const EmptyStateWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  padding: 60px 20px;
  flex: 1;
  min-height: 0;
`;

export const EmptyStateTitle = styled.h3`
  font-size: 24px;
  font-weight: 600;
  color: ${(props) => props.theme.colors.text};
  margin: 0;
`;

export const EmptyStateDescription = styled.p`
  font-size: 16px;
  color: ${(props) => props.theme.colors.textSecondary};
  margin: 0;
  text-align: center;
`;

